import { NextSeo } from 'next-seo';
import { useIntl } from 'react-intl';

import { MarginWrapper } from '@/core/components/MarginWrapper';
import { Breadcrumbs } from '@/core/components/Breadcrumbs';
import {
  Subheader,
  Title,
  TitleWrapper,
} from '@/core/components/PageLayout';
import { navigationMessages } from '@/core/messages/navigation.messages';
import { useLocalizedOGTitle } from '@/core/hooks/useLocalizedOGTitle';
import { VectorBanner } from '@/core/components/VectorBanner';
import { Color } from '@/core/interfaces/common';

import { getKeywordsProps } from '@/utils/helpers';

import { BookPageData } from './Book.types';
import {
  BookWrapper,
  Wrapper,
} from './Book.styles';

type BookPageProps = {
  pageData: BookPageData;
}

export const BookPage = ({ pageData }: BookPageProps) => {
  const { formatMessage } = useIntl();
  const {
    banner,
    header,
    meta,
    content,
  } = pageData;

  const OGTitle = useLocalizedOGTitle(
    meta?.OGTitle || meta?.title || formatMessage(navigationMessages.about)
  );

  return (
    <>
      <NextSeo
        title={meta?.title || formatMessage(navigationMessages.book)}
        description={meta?.description || ''}
        openGraph={{
          description: meta?.OGDescription || meta?.description || '',
          title: OGTitle,
        }}
        {...getKeywordsProps(meta?.keywords)}
      />
      <VectorBanner
        header={banner.header}
        subheader={banner.paragraph}
        color={banner.backgroundColor || Color.GREEN}
      />
      <Breadcrumbs />
      <Wrapper>
        <MarginWrapper>
          {header && (
            <TitleWrapper>
              <Subheader>{header.subtitle}</Subheader>
              <Title>{header.title}</Title>
            </TitleWrapper>
          )}
          <BookWrapper>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </BookWrapper>
        </MarginWrapper>
      </Wrapper>
    </>
  );
};
